var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "drag-dialog",
        _vm._g(
          _vm._b(
            {
              staticClass: "gl-new-dialogPop ",
              attrs: {
                title: _vm.$t("home.buttonCopy"),
                isShowFollow: false,
                isShowFull: false,
              },
              on: { opened: _vm.opened },
            },
            "drag-dialog",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _c("div", { staticClass: "panel-body" }, [
            _c(
              "div",
              { staticClass: "filter-container-content" },
              [
                _c(
                  "el-form",
                  {
                    ref: "filterForm",
                    attrs: { rules: _vm.rules, model: _vm.filterForm },
                  },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 1 } },
                      [
                        _c(
                          "el-col",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "flex-end",
                            },
                            attrs: { span: 20 },
                          },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "reqired",
                                staticStyle: { width: "30%" },
                                attrs: {
                                  prop: "copyCount",
                                  label: _vm.$t("home.copyNumber") + "：",
                                },
                              },
                              [
                                _c("el-input-number", {
                                  attrs: {
                                    precision: 0,
                                    "auto-cut": true,
                                    controls: false,
                                    max: 9999,
                                  },
                                  model: {
                                    value: _vm.filterForm.copyCount,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.filterForm,
                                        "copyCount",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "filterForm.copyCount",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-radio-group",
                              {
                                staticStyle: { padding: "0 0 10px 30px" },
                                model: {
                                  value: _vm.filterForm.bkType,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filterForm, "bkType", $$v)
                                  },
                                  expression: "filterForm.bkType",
                                },
                              },
                              [
                                _c(
                                  "el-radio",
                                  {
                                    attrs: {
                                      label: 0,
                                      disabled: _vm.unableAutoGeneral,
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("home.copySix")))]
                                ),
                                _vm._v(" "),
                                _c("el-radio", { attrs: { label: 1 } }, [
                                  _vm._v(_vm._s(_vm.$t("home.copyTwo"))),
                                ]),
                                _vm._v(" "),
                                _c("el-radio", { attrs: { label: 2 } }, [
                                  _vm._v(_vm._s(_vm.$t("home.copyThree"))),
                                ]),
                                _vm._v(" "),
                                _c("el-radio", { attrs: { label: 3 } }, [
                                  _vm._v(_vm._s(_vm.$t("home.copyFour"))),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 14 } },
                      [
                        _c("el-col", { attrs: { span: 8 } }),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 8 } }),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 5 } }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "text-align": "right",
                      margin: "20px 0 0px 0",
                    },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-bottom": "20px" },
                        attrs: { type: "primary", plain: "" },
                        on: { click: _vm.handleSubimtSign },
                      },
                      [_vm._v(_vm._s(_vm.$t("home.copySubimtButtonOpen")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-bottom": "20px" },
                        attrs: { type: "primary", plain: "" },
                        on: { click: _vm.handleSubimt },
                      },
                      [_vm._v(_vm._s(_vm.$t("home.copySubimtButton")))]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("CheckNotice", {
        ref: "checkNotice",
        on: { handleCheckSubmit: _vm.handleCheckSubmit },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }